module Omni.ResortMap {
    export let ngModule = angular.module("omni.resortmap", [
        "omniViews"
    ]);
}